import React from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import Label from '../Label';
import { classNames } from 'primereact/utils';

const FormikAutocomplete = (props) => {
  const {
    labelText,
    isMandatory = false,
    formik,
    name,
    value,
    className,
    onChange,
    ...rest
  } = props;

  const isInvalid = !!(formik.touched[name] && formik.errors[name]);
  const mergeClassName = classNames(className, {
    'p-invalid': isInvalid
  });
  return (
    <>
      {labelText && <Label htmlFor={name} text={labelText} isMandatory={isMandatory} />}
      <AutoComplete
        {...rest}
        id={name}
        name={name}
        value={value || formik.values[name]}
        onChange={onChange || formik.handleChange}
        onBlur={formik.handleBlur}
        className={mergeClassName}
      />
      {isInvalid && <small className="p-error">{formik.errors[name]}</small>}
    </>
  );
};

export default FormikAutocomplete;
